import { type EditorProps, EditorTools } from '@progress/kendo-react-editor'

import { InsertDocumentImageTool } from './InsertDocumentImageTool'

const {
  AddColumnAfter,
  AddColumnBefore,
  AddRowAfter,
  AddRowBefore,
  Bold,
  BulletedList,
  CleanFormatting,
  DeleteColumn,
  DeleteRow,
  DeleteTable,
  FindAndReplace,
  FormatBlock,
  InsertImage,
  InsertTable,
  Italic,
  Link,
  MergeCells,
  NumberedList,
  Redo,
  SplitCell,
  Strikethrough,
  Underline,
  Undo,
  Unlink,
} = EditorTools

export const tools: EditorProps['tools'] = [
  InsertDocumentImageTool,
  FindAndReplace,
  [Undo, Redo],
  FormatBlock,
  [Bold, Italic, Underline, Strikethrough],
  [CleanFormatting],
  [BulletedList, NumberedList],
  [Link, Unlink, InsertImage],
  InsertTable,
  [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
  [DeleteRow, DeleteColumn, DeleteTable],
  [MergeCells, SplitCell],
]
